// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610140817/js/" + chunkId + "." + {"44":"4654293c","225":"5d702597","481":"355558bf","486":"be6899e0","770":"c9f6bfd8"}[chunkId] + ".0.18196942681290929.chunk.js";
};